import '../App.css';
import { Button, ButtonGroup, Navbar, Nav } from 'react-bootstrap';
import 'sf-font';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faTelegram, faDiscord } from '@fortawesome/free-brands-svg-icons';

import React, { Component } from 'react';

import ABI from '../ABI.json';

import { NFTCONTRACT } from '../config';
import Web3Modal from "web3modal";
import Web3 from 'web3';
import WalletConnectProvider from "@walletconnect/web3-provider";
import WalletLink from "walletlink";

const providerOptions = {
  walletconnect: {
    package: WalletConnectProvider,
    options: {
      infuraId: "64d1bed94f1d40908f08965a0400ac56"
    }
  },
  walletlink: {
    package: WalletLink,
    options: {
      appName: "JustPoly",
      infuraId: "64d1bed94f1d40908f08965a0400ac56",
      rpc: "",
      chainId: 317,
      appLogoUrl: null,
      darkMode: true
    }
  },
};

const web3Modal = new Web3Modal({
  network: "mainnet",
  theme: "dark",
  cacheProvider: true,
  providerOptions
});

class App extends Component {
  constructor() {
    super();
    this.state = {
      isConnected: false,
      countdown: 0,
      outvalue: 0,
    };

    this.connectWallet = this.connectWallet.bind(this);
    this.startCountdown = this.startCountdown.bind(this);
    this.handleNFT = this.handleNFT.bind(this);
    this.mint = this.mint.bind(this);
  }

  componentDidMount() {
    this.startCountdown();
  }

  handleNFT(nftamount) {
    this.setState({ outvalue: nftamount.target.value });
  }

  async connectWallet() {
    try {
      const provider = await web3Modal.connect();
      await web3Modal.toggleModal();
      const web3 = new Web3(provider);
      await provider.request({ method: 'eth_requestAccounts' });
      const accounts = await web3.eth.getAccounts();
      const account = accounts[0];
      document.getElementById('wallet-address').textContent = account;
      
      // Update the connection status
      this.setState({ isConnected: true });
    } catch (error) {
      console.error('Failed to connect wallet:', error);
    }
  }

  async mint() {
    try {
      const provider = await web3Modal.connect();
      const web3 = new Web3(provider);
      await provider.request({ method: 'eth_requestAccounts' });
      const accounts = await web3.eth.getAccounts();
      const account = accounts[0];
      const contract = new web3.eth.Contract(ABI, NFTCONTRACT);

      const gasLimit = 200000;
      const gasPrice = await web3.eth.getGasPrice();
      const gasPriceBN = web3.utils.toBN(gasPrice);
      const maxBaseFee = gasPriceBN.muln(1);
      const maxPriorityFee = gasPriceBN;
      console.log('Max Base Fee:', web3.utils.fromWei(maxBaseFee.toString(), 'gwei'));
      console.log('Max Priority Fee:', web3.utils.fromWei(maxPriorityFee.toString(), 'gwei'));

      const _mintAmount = Number(this.state.outvalue);
      const mintRate = Number(await contract.methods.cost().call());
      const totalAmount = mintRate * _mintAmount;

      await contract.methods.mint(account, _mintAmount).send({
        from: account,
        value: String(totalAmount),
        gasPrice: maxBaseFee,
        maxPriorityFeePerGas: maxPriorityFee,
        gas: gasLimit,
      });

      console.log('Airdrop claimed successfully!');
    } catch (error) {
      console.error('Failed to claim airdrop:', error);
    }
  }

  startCountdown() {
    const countdownInterval = setInterval(() => {
      const now = new Date();
      const eventDate = new Date('2023-08-23T00:00:00Z');
      const diff = eventDate - now;

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      const countdown = `${days} D , ${hours} H , ${minutes} M , ${seconds} S`;

      this.setState({ countdown });

      if (diff < 0) {
        clearInterval(countdownInterval);
        this.setState({ countdown: 'CLAIMED ENDED' });
      }
    }, 1000);
  }

  render() {
    const { isConnected, countdown, outvalue } = this.state;
    const currentYear = new Date().getFullYear();

    return (
  <header className="App-header">
    <div className='container' style={{ background: " #000000" }}>
      
     
    <div className="nftminter" style={{ border: "0", borderRadius: "5px", background: "transparent", marginTop: "10px", marginBottom: "10px", }}>
             
             <Navbar collapseOnSelect expand="md"  variant="dark" style={{ color: 'transparent', background: "transparent", marginRight: "3px",marginLeft: "3px", border: "0", }}>
             
             
             <div className="social-icons">
             <a href="https://twitter.com/JustPoly">
   <FontAwesomeIcon icon={faTwitter} type= "button"size="lg" className="social-icon" />
   </a>
   <a href="">
   <FontAwesomeIcon icon={faTelegram} size="lg" className="social-icon" />
   </a>
   <a href="">
   <FontAwesomeIcon icon={faDiscord} size="lg" className="social-icon" />
   </a>
   
   <style>
     {`
       .social-icons {
         display: flex;
         justify-content: center;
       
         color: #ccc;
         margin-right: auto;
       }

       .social-icon {
         margin-right: 10px;
         margin-left: 10px;
       }

       a {
         color: #ccc;
       }
       a:hover {
         color:#aaa;
        
       }


       @media (max-width: 768px) {
         .social-icons {
           display: flex;
           justify-content: left;
          
           color: #ccc;
           
        
         }
       }
     `}
   </style>
 </div>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" style={{color:"transparent", background: "transparent", marginTop: "auto", border: "0", }}/>
       
        <Navbar.Collapse id="responsive-navbar-nav"  style={{textAlign: "left", background: "transparent", marginTop: "auto", border: "0", }}>
        
         <Nav className="mr-auto ml-auto ml-lg-0" >
         <Button variant="default" href="/" style={{ color: "#ccc", backgroundColor: "#ffffff10", margin: "5px", marginTop: "5px" }}>HOME</Button>
         <Button variant="default" href="/about" style={{ color: "#ccc", backgroundColor: "#ffffff10", margin: "5px", marginTop: "5px" }}>ABOUT</Button>
         <Button variant="default" href="/tokenInfo" style={{ color: "#ccc", backgroundColor: "#ffffff10", margin: "5px", marginTop: "5px" }} >TOKEN INFO</Button>
         <Button variant="default" href="/roadmap" style={{ color: "#ccc", backgroundColor: "#ffffff10", margin: "5px", marginTop: "5px" }} >ROADMAP</Button>
         <Button variant="default" href="" style={{ color: "#ccc", backgroundColor: "#ffffff10", margin: "5px", marginTop: "5px" }} >STAKED</Button>    
       </Nav></Navbar.Collapse></Navbar></div>

         


      <div className='col'>
        <div className='nftminter' style={{ background: "transparent", marginTop: "auto", border: "0" }}>
          <form>
            <div className="row pt-3">
              <div style={{ marginTop: "10px", fontWeight: "auto", fontSize: "18px" }}></div>
              <div></div>
            </div>
            <div className="imgBox">
              <img src="JP.gif" alt="image" style={{ width: "300px", height: "300px" }} />
           
           
            </div>
            <label id="wallet-address" style={{ marginTop: "auto", marginBottom: "auto", fontWeight: "auto", fontSize: "13px" }}>Your Wallet Addres</label>
              <div className='info'>
         
      <label id="countdown" style={{ marginTop: "15px", marginBottom: "15px", fontWeight: "bold", fontSize: "13px" }}>CLAIM PERIOD ENDS IN : {countdown}</label>
        </div>

        <div className="nftsB" style={{ background: "transparent", marginTop: "auto", marginBottom: "auto", }}>
                    <ButtonGroup size="lg"
                      aria-label="First group"
                      name="amount"
                      onClick={nftamount => this.handleNFT(nftamount, "value")} >
                      <Button variant="default" style={{ color: "#ccc", backgroundColor: "#ffffff10", marginTop: "auto" }} value="1">1</Button>
                      <Button variant="default" style={{ color: "#ccc", backgroundColor: "#ffffff10", marginTop: "auto" }} value="2">2</Button>
                      <Button variant="default" style={{ color: "#ccc", backgroundColor: "#ffffff10", marginTop: "auto" }} value="3">3</Button>
                      <Button variant="default" style={{ color: "#ccc", backgroundColor: "#ffffff10", marginTop: "auto" }} value="4">4</Button>
                      <Button variant="default" style={{ color: "#ccc", backgroundColor: "#ffffff10", marginTop: "auto" }} value="5">5</Button>
                    </ButtonGroup>
                  </div>

    <Button variant="default" className='btn-get-started' 
              
              onClick={isConnected ? this.mint : this.connectWallet} 
              
              style={{ color: "#ccc", backgroundColor: "#ffffff10", marginBottom:"20px",marginTop: "10px", }}>
                
                {isConnected ? 'MINT NOW' : 'CONNECT WALLET'}</Button>

                
         

            


          </form>
        </div>
      </div>
      <div className='footer' style={{ background: "transparent", border: "0" }}>
        <div className='col'>
          <div className='nftminter' style={{ background: "transparent", marginTop: "10px", border: "0" }}>
          
         
                <label id='text' style={{ textAlign: "left", margin: "10px", color: "#ccc",marginTop: "5px", fontWeight: "bold", fontSize: "15px" }}>

                <h2>With great pleasure, we bring you some exciting news!</h2>


<p>We are thrilled to announce our first airdrop, exclusively for the launch day of JUST POLY.</p>

<p>We are delighted to offer this airdrop opportunity to all participants.</p>

<p>You will have the chance to claim at least 5,000 GENESIS NFTs of JUST POLY for free on the designated website we have provided.</p>

<p>The claiming process will commence within the end COUNT DOWN time on the WEBSITE.</p>

<p>Furthermore, we would like to highlight that all GENESIS NFT holders will be guaranted received of JUSTPOLY ($JP) token, with a total value 50,000 for each GENESIS NFT owned.</p>

<style>{`
  
        h1, h2, p, li {
          text-align: left;
        
        
        }

      
      `}</style>
      </label>
                   
          </div>
          <b>&copy; {currentYear} JUST POLY DAPP</b>
          <style>{`
  
        b {
          text-align: center;
          font-size: 14px;
          font-weight: arial;
        }

      
      `}</style>
        </div>
      </div>
    </div>
  </header>
);
}
}

export default App;